export const PRISMA_NEW = 'new';
export const PRISMA_REMOVED = 'removed';
export const PRISMA_UPDATED = 'updated';
